import ApiService from "../ApiService";

const unifiedPharmacyService = {
    create(unifiedPharmacy) {
        return ApiService.post(`/unified-pharmacy`, unifiedPharmacy);
    },

    get() {
        return ApiService.get(`/unified-pharmacy`);
    },
    update(id, data) {
        return ApiService.post(`/unified-pharmacy/update?id=${id}`, data);
    },
    delete(data) {
        return ApiService.post(`/unified-pharmacy/remove`, data);
    }
};

export default unifiedPharmacyService;
